// useSnackbar.js

import CartSnackbar from "@/components/cartSnackbar";
import ToastBody from "@/components/toastBody";
import { useToast } from "@/hooks/use-toast";

export function useShowSnackbar() {
  const { toast } = useToast();

  const showSnackbar = (message = "", variant = "default") => {
    toast({
      variant,
      description: <ToastBody description={message} variant={variant} />,
    });
  };

  const showCartSnackbar = (product = {}, quantity = 0, cartInputValue, inputQuantity, variant = "default") => {
    toast({
      description: (
        <CartSnackbar
          product={product}
          quantity={quantity}
          inputQuantity={inputQuantity}
          cartInputValue={cartInputValue}
          title="Product added to cart"
        />
      ),
      variant: variant,
      duration: 2000,
    });
  };

  return { showSnackbar, showCartSnackbar };
}
